import { Document, Schema, Model, model } from 'mongoose';

import { Translation } from '../../shared/types/translation';

export type TranslationDocument = Translation & Document;

export const TranslationSchema: Schema = new Schema(
  {
    refers: Schema.Types.ObjectId,
    type: String,
    transforms: {
      required: false,
      type: Map,
      of: new Schema({
        active: Boolean,
        timestamp: String,
        delta: Object,
      }),
    },
  },
  { timestamps: true }
);

export const TranslationModel: Model<TranslationDocument> = model<TranslationDocument>(
  'Translation',
  TranslationSchema
);
